import { h } from "@stencil/core";
import { IconType } from "./icon-type.enum";
import { BOSCH_FONT_ICON_CSS_CLASS_PREFIX, BOSCH_UI_ICON_CSS_CLASS_PREFIX, PAU_BBG_FONT_ICONS_CSS_CLASS_PREFIX } from "../../shared/constants";
import { IconSource } from "./icon-source.enum";
import { renderInlineError } from "../../../utils";
export class BbgIcon {
  constructor() {
    /** The icons's type which is dependent on the host element. E.g. if the icon is a child element of the button then type 'button' should be specified. Possible values: plain, button */
    this.type = IconType.plain;
    /** The source of the icon (i.e. where the icon is stored). Possible values: BoschFontIcons, BoschUiIcons and PauBbgFontIcons */
    this.source = IconSource.BoschFontIcons;
  }
  render() {
    if (IconType[this.type] === undefined) {
      return renderInlineError(`Unknown icon type '${this.type}'`);
    }
    if (IconSource[this.source] === undefined) {
      return renderInlineError(`Unknown icon source '${this.source}'`);
    }
    let cssClasses = {
      "a-icon": true,
      "a-pau-bbg-icon": this.source === IconSource.PauBbgFontIcons,
      "a-button__icon": this.type === IconType.button,
      "a-text-field__icon": this.type === IconType.textField,
    };
    let iconCssClassPrefix;
    switch (this.source) {
      case IconSource.BoschFontIcons:
        iconCssClassPrefix = BOSCH_FONT_ICON_CSS_CLASS_PREFIX;
        break;
      case IconSource.BoschUiIcons:
        iconCssClassPrefix = BOSCH_UI_ICON_CSS_CLASS_PREFIX;
        break;
      case IconSource.PauBbgFontIcons:
        iconCssClassPrefix = PAU_BBG_FONT_ICONS_CSS_CLASS_PREFIX;
        break;
      default:
        throw "IconSource type " + this.source + " known but not handled";
    }
    cssClasses[`${iconCssClassPrefix}${this.name}`] = true;
    return h("i", { class: cssClasses, title: this.iconTitle });
  }
  static get is() { return "bbg-icon"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-icon.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-icon.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The icons's type which is dependent on the host element. E.g. if the icon is a child element of the button then type 'button' should be specified. Possible values: plain, button"
        },
        "attribute": "type",
        "reflect": false,
        "defaultValue": "IconType.plain"
      },
      "source": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The source of the icon (i.e. where the icon is stored). Possible values: BoschFontIcons, BoschUiIcons and PauBbgFontIcons"
        },
        "attribute": "source",
        "reflect": false,
        "defaultValue": "IconSource.BoschFontIcons"
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The name of the icon within the source. See https://brandguide.bosch.com/document/79#/schrift-typografie/bosch-icon for the icon names within the Bosch Icon Font."
        },
        "attribute": "name",
        "reflect": false
      },
      "iconTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The icon title"
        },
        "attribute": "icon-title",
        "reflect": false
      }
    };
  }
}
